/**
 * @generated SignedSource<<b545af1bbbe78bc9a1b11fcae46523d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ControllerReleaseMaxFilter_query$data = {
  readonly controllerReleases: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly releaseKey: string;
        readonly uuid: string;
        readonly versionString: string | null;
      } | null;
    } | null>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "ControllerReleaseMaxFilter_query";
};
export type ControllerReleaseMaxFilter_query$key = {
  readonly " $data"?: ControllerReleaseMaxFilter_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ControllerReleaseMaxFilter_query">;
};

import ControllerReleaseMaxFilterRefetchQuery_graphql from './ControllerReleaseMaxFilterRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "controllerReleases"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "maxVersion"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ControllerReleaseMaxFilterRefetchQuery_graphql
    }
  },
  "name": "ControllerReleaseMaxFilter_query",
  "selections": [
    {
      "alias": "controllerReleases",
      "args": [
        {
          "kind": "Variable",
          "name": "maxVersion",
          "variableName": "maxVersion"
        },
        {
          "kind": "Literal",
          "name": "versioned",
          "value": true
        }
      ],
      "concreteType": "ControllerReleaseConnection",
      "kind": "LinkedField",
      "name": "__ControllerReleaseMaxFilter_controllerReleases_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ControllerReleaseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ControllerRelease",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "versionString",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "releaseKey",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "e0972510d979a8ce3dc6fb055a47ea49";

export default node;
